import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
const pillars = [{
  letter: 'C',
  title: 'Calibrare',
  subtitle: 'Săptămânile 1–4',
  desc: 'Începem cu o scanare completă a corpului tău (BIA și biorezonanță). Definim punctul de plecare real și stabilim exact ce trebuie reparat mai întâi. Fără presupuneri.'
}, {
  letter: 'E',
  title: 'Energie',
  subtitle: 'Săptămânile 5–8',
  desc: 'Îți optimizăm producția de energie la nivel celular. Introducem suplimentarea potrivită corpului tău și eliminăm căderea de energie de după prânz.'
}, {
  letter: 'L',
  title: 'Longevitate',
  subtitle: 'Săptămânile 9–12',
  desc: 'Testăm flexibilitatea metabolismului tău. Reintroducem alimente pe baza datelor, nu a opiniilor. Construim un sistem rezistent care funcționează și în vacanță, și la birou.'
}, {
  letter: 'OS',
  title: 'Optimizare Sistemică',
  subtitle: 'Săptămânile 13–16',
  desc: 'Îți predăm cheile. La final, știi exact ce să mănânci, ce suplimente îți trebuie și cum să te adaptezi la orice situație: călătorii, stres, cine de business. Ești autonom.'
}];
export function Method() {
  return <section className="bg-brand-light py-16 lg:py-20 relative overflow-hidden" data-id="element-160">
      {/* Subtle dot grid background */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1B2A4A 2px, transparent 2px)',
      backgroundSize: '32px 32px'
    }} data-id="element-161"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-navy mb-6" data-id="element-164">
            Metoda C.E.L.O.S. — 4 faze spre controlul biologiei tale
          </h2>
          <p className="font-lora text-[19px] md:text-xl text-text-medium max-w-3xl mx-auto leading-relaxed" data-id="element-165">
            Un proces structurat de 6 luni prin care treci de la un corp pe care
            nu-l mai înțelegi la un sistem biologic pe care-l conduci tu. Fără
            restricții extreme, cu date clare la fiecare pas.
          </p>
        </motion.div>

        {/* Vertical Journey */}
        <div className="relative" data-id="element-166">
          {/* Vertical timeline line */}
          <div className="absolute left-8 md:left-1/2 md:-translate-x-px top-0 bottom-0 w-[2px] bg-gold/20 z-0" data-id="element-167"></div>

          {pillars.map((pillar, idx) => {
          const isLeft = idx % 2 === 0;
          return <div key={idx} className="relative" data-id="element-168">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: idx * 0.15
            }} className={`flex items-start gap-6 md:gap-12 mb-6 ${isLeft ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-169">
                  {/* Content Card */}
                  <div className={`flex-1 ml-20 md:ml-0 ${isLeft ? 'md:text-right' : 'md:text-left'}`} data-id="element-170">
                    <div className={`bg-white rounded-lg p-8 shadow-sm border border-border-subtle inline-block w-full hover:-translate-y-1 hover:shadow-md transition-all duration-300`} data-id="element-171">
                      <span className="font-inter text-[17px] font-semibold text-gold uppercase tracking-widest" data-id="element-172">
                        {pillar.subtitle}
                      </span>
                      <h3 className="font-montserrat font-bold text-navy text-2xl mt-2 mb-4" data-id="element-173">
                        {pillar.title}
                      </h3>
                      <p className="font-inter text-text-medium text-[19px] leading-relaxed" data-id="element-174">
                        {pillar.desc}
                      </p>
                    </div>
                  </div>

                  {/* Center Node */}
                  <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 flex flex-col items-center z-10" data-id="element-175">
                    <div className="w-16 h-16 rounded-2xl bg-navy flex items-center justify-center shadow-lg border-4 border-brand-light" data-id="element-176">
                      <span className="font-montserrat font-bold text-2xl text-gold" data-id="element-177">
                        {pillar.letter}
                      </span>
                    </div>
                  </div>

                  {/* Spacer for the other side */}
                  <div className="flex-1 hidden md:block" data-id="element-178"></div>
                </motion.div>

                {/* Arrow between steps */}
                {idx < pillars.length - 1 && <div className="flex justify-center my-2 relative z-10" data-id="element-179">
                    <div className="absolute left-8 md:left-1/2 md:-translate-x-1/2 -translate-x-0" data-id="element-180">
                      <ArrowDownIcon className="w-5 h-5 text-gold/50" data-id="element-181" />
                    </div>
                  </div>}
              </div>;
        })}

          {/* Journey End Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="flex justify-center mt-10 relative z-10" data-id="element-182">
            <div className="absolute left-8 md:left-1/2 md:-translate-x-1/2 -translate-x-0" data-id="element-183">
              <div className="w-16 h-16 rounded-full bg-gold flex items-center justify-center shadow-lg" data-id="element-184">
                <span className="font-montserrat font-bold text-navy text-lg" data-id="element-185">
                  ✓
                </span>
              </div>
            </div>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} className="text-center mt-20 font-lora italic text-[19px] text-text-medium" data-id="element-186">
            Ești autonom. Controlul e al tău.
          </motion.p>
        </div>
      </div>
    </section>;
}